import { Button, Link, Menu } from '@material-ui/core';
import './style.scss';
import { memo, useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/16/solid';
import { ElementorIcon, BeaverBuilderIcon, GutenbergIcon } from './icons';
import { useSiteLinks } from './hooks/useSiteLinks';

const PreviewMenu = ( props ) => {
	const { attrs, pageBuilders = [] } = props;

	const [ anchorEl, setAnchorEl ] = useState( null );
	const siteLinks = useSiteLinks( attrs?.site_id );

	const open = Boolean( anchorEl );
	const handleClick = ( event ) => {
		setAnchorEl( event.currentTarget );
	};
	const handleClose = () => {
		setAnchorEl( null );
	};

	const pageBuilderOptions = [
		{
			label: 'Elementor',
			icon: <ElementorIcon />,
			link: siteLinks.elementor,
			slug: 'elementor',
		},
		{
			label: 'Beaver Builder',
			icon: <BeaverBuilderIcon />,
			link: siteLinks[ 'beaver-builder' ],
			slug: 'beaver-builder',
		},
		{
			label: 'Gutenberg',
			icon: <GutenbergIcon />,
			link: siteLinks.gutenberg,
			slug: 'gutenberg',
		},
	];

	const options = pageBuilderOptions.map( ( builder ) =>
		pageBuilders.includes( builder.slug ) ? builder : undefined,
	);

	return (
		<>
			<Button
				id="preview-button"
				aria-controls={ open ? 'preview-menu' : undefined }
				aria-haspopup="true"
				aria-expanded={ open ? 'true' : undefined }
				onClick={ handleClick }
				variant="outlined"
			>
				{ attrs?.text }
				<ChevronDownIcon
					style={ { paddingLeft: '8px', width: '24px' } }
				/>
			</Button>
			<Menu
				id="preview-menu"
				anchorEl={ anchorEl }
				open={ open }
				onClose={ handleClose }
				MenuListProps={ {
					'aria-labelledby': 'preview-button',
					style: {
						padding: '6px',
						borderRadius: '4px',
						display: 'flex',
						gap: '4px',
						flexDirection: 'column',
					},
				} }
				PaperProps={ {
					style: {
						boxShadow: '0px 0px 10px 0px #00000012',
						marginTop: '62px',
					},
				} }
			>
				{ options?.map( ( option, i ) => (
					<span key={ i }>
						{ option && (
							<Link
								href={ option?.link }
								target="_blank"
								onClick={ handleClose }
								className="preview-links"
							>
								<span style={ { paddingTop: '4px' } }>
									{ option?.icon }
								</span>
								<span>{ option?.label }</span>
							</Link>
						) }
					</span>
				) ) }
			</Menu>
		</>
	);
};

export default memo( PreviewMenu );
